import React from 'react';

import ListUsers from "./user-list";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import './User.scss';

const User = () => {
  return (
    <>
      <Navbar />
      <div className="min-h-full flex justify-center items-center campain-table-container container">
        <div className="table-wrapper w-full">
          <div className="campain-title">
            <h2 className="text-center mt-3">Users</h2>
          </div>
          <ListUsers />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default User;
